/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Api_Reference_Related_AgentsInputs */

const en_directory_api_reference_related_agents = /** @type {(inputs: Directory_Api_Reference_Related_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For AI agents`)
};

const zh_directory_api_reference_related_agents = /** @type {(inputs: Directory_Api_Reference_Related_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`面向 AI Agent`)
};

/**
* | output |
* | --- |
* | "For AI agents" |
*
* @param {Directory_Api_Reference_Related_AgentsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_api_reference_related_agents = /** @type {((inputs?: Directory_Api_Reference_Related_AgentsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Api_Reference_Related_AgentsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_api_reference_related_agents(inputs)
	return zh_directory_api_reference_related_agents(inputs)
});
export { directory_api_reference_related_agents as "directory.api_reference.related_agents" }